import React from 'react'
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import Footer from '../Footer/Footer';

function AccessibilityStatement() {
  return (
    <div>
        <SideBar></SideBar>
        <TopBaner></TopBaner>
         <div className="card" style={{ textAlign: "right", direction: "rtl" }}>
      <img src="/pycBlueIogo.png" alt="logo-pych" style={{ height: "100px" }} />
      <h5>הצהרת נגישות</h5>
      <div>חברת פאייכלה רואה חשיבות רבה במתן שירות שוויוני ונגיש לכלל המשתמשים, ולכן פועלת כדי לאפשר חוויית שימוש נגישה באתר האינטרנט שלה.</div>
        <div>
        באתר יושמו מגוון התאמות נגישות בהתאם להנחיות התקן הישראלי (ת"י 5568) ולתקן הבינלאומי WCAG 2.0 ברמת AA, ובהן:
      </div>
      <ul>
        <li>אפשרות לשינוי ניגודיות צבעים.</li>
        <li>התאמה לשימוש בקורא מסך.</li>
        <li>אפשרות להגדלת טקסט והקטנתו.</li>
      </ul>
      <div>החברה פועלת לשפר את הנגישות באופן מתמיד, ככל שניתן במסגרת האפשרויות הטכנולוגיות.</div>
      <p>אם נתקלת בבעיה או בהצעה לשיפור, נשמח לשמוע ממך.</p>
      <p>ניתן ליצור קשר בכתובת הדוא"ל: PRH700262@gmail.com.</p>
      </div>
    
      
        <Footer></Footer>
    </div>
  )
}

export default AccessibilityStatement